import request from '@/utils/request'

// 查询确认单模板
export function findConfirmationFormTemplate(params) {
  return request({
    url: `/confirmation_form_template`,
    method: 'get',
    params: params
  })
}

// 更新确认单模板
export function updateConfirmationFormTemplate(data) {
  return request({
    url: `/confirmation_form_template`,
    method: 'put',
    data
  })
}
